// extracted by mini-css-extract-plugin
export default {"container":"oD-z","dimension":"pD-z","dimensionLabels":"qD-z"};